<template>
  <div class="page" :class="{'is-mobile' : $vuetify.breakpoint.mobile}">
    <div class="content">
      <v-container fluid>
        <div class="ma-2">
          <span class="titulo">Olá, {{userName}},</span>
          <br/>
          <span class="sub-titulo">Como você está se sentindo hoje?</span>
        </div>
        <div class="ma-2">
          <v-expansion-panels
            v-model="panel"
            multiple expanded>
            <v-expansion-panel :key="0" class="ma-2 rounded-border">
              <v-expansion-panel-header class="titulo">
                {{mensagemDemandasEmAtendimento}}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <DeuMatchPainelDataTable ref="demandasEmAtendimento"
                  :search-values="{
                    flgStatusDemanda: 'A',
                    itemPorPagina: 12
                  }"/>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel :key="1" class="ma-2 rounded-border">
              <v-expansion-panel-header class="titulo">
                {{mensagemDemandasSemAtendimento}}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <DemandaPainelDataTable ref="demandasSemAtendimento"
                  @onMatch="() => $refs.demandasEmAtendimento.refresh()"
                  :search-values="{
                    tipoBusca: 'DISPONIVEL',
                    itemPorPagina: 12
                  }"/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import BaseView from "../BaseView";
import DemandaPainelDataTable from "../../components/shared/datatables/DemandaPainelDataTable";
import DeuMatchPainelDataTable from "../../components/shared/datatables/DeuMatchPainelDataTable";
import CardPersonalizado from "../../components/shared/common/CardPersonalizado";
import {mapGetters} from "vuex";

export default {
  name: "Painel",
  components: {BaseView, DemandaPainelDataTable, DeuMatchPainelDataTable, CardPersonalizado},
  data() {
    return {
      isLoadingG1: false,
      isLoadingG2: false,
      isLoadingG3: false,
      graficoAtual: "",
      panel: [0,1],
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated', 'nivelUsuarioLogado']),
    userName: {
      get() {
        return this.isFornecedorOuComprador(this.nivelUsuarioLogado) ? this.user?.nomeResponsavel : this.user?.nome;
      }
    },
    mensagemDemandasEmAtendimento(){
      return (this.isFornecedorOuComprador(this.nivelUsuarioLogado) ? "Minhas " : "") + "Demandas em negociação";
    },
    mensagemDemandasSemAtendimento(){
      return (this.nivelUsuarioLogado === 'COM' ? "Minhas " : "") + "Demandas disponíveis para negociação";
    },
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
/*.page {
  border:2px solid red;
}*/
.page .is-mobile {
  .content {
    overflow: auto;
    max-height: calc(100vh - 60px);
  }

  ::v-deep {
    .v-data-table__wrapper {
      height: calc(100vh - 97px);
    }
  }
}

.page .content {
  /*border:2px solid green;*/
  overflow: auto;
  max-height: calc(100vh - 50px);
  width: 100%;
  flex: 1;

  ::v-deep {
    .v-data-table__wrapper {
      height: calc(100vh - 157px);
    }
  }
}
.rounded-border {
  border-radius: 8px !important;
  border: 0px !important;
}
.titulo {
  font-size: 1em;
  font-weight: bold;
  color:#167ABC;
}
.sub-titulo {
  font-size: 0.8em;
}
.titulo-grafico {
  font-size: 1em;
  font-weight: bold;
  color:black;
}
.chart-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%; /* Ajuste conforme necessário */
}
</style>